<template>
    <div class="tc-modal-rename tc-modal-body">
        <div class="tc-modal-label">
            Переименовать
        </div>
        <div class="tc-modal-input-group">
            <div class="tc-modal-text">
                Имя:
            </div>
            <input class="tc-default-input"
                   :value="name"
                   @input="name = $event.target.value">
        </div>
        <div class="tc-field-error-anchor"
             v-show="isErrorName">
            <div class="tc-field-error">
                Не менее 2 смволов!
            </div>
        </div>
        <div class="tc-modal-two-buttons">
            <OutlineButton :text="'Отмена'"
                           @click="cancel()"/>
            <OrangeButtonOfLawlessness :text="'Сохранить'"
                                       @click="submit()"/>
        </div>
    </div>
</template>

<script>

import OutlineButton from '@/UI/CommonComponents/OutlineButton.vue';
import OrangeButtonOfLawlessness from '@/UI/CommonComponents/OrangeButtonOfLawlessness.vue';
import { useStoreUI } from '@/Store/storeUI';
import { useStoreRenameCase } from '@/Store/storeRenameCase';
import { useStoreProjectStructure } from '@/Store/storeProjectStructure';
import { useStoreNotifications } from '@/Store/storeNotifications';
import { generateNotification } from '@/libs/generateNotification';

export default {
    name: 'ModalRename',
    components: {
        OrangeButtonOfLawlessness,
        OutlineButton,
    },
    setup() {
        const storeUI = useStoreUI();
        const storeRenameCase = useStoreRenameCase();
        const storeProjectStructure = useStoreProjectStructure();
        const storeNotifications = useStoreNotifications();
        return {
            storeUI,
            storeRenameCase,
            storeProjectStructure,
            storeNotifications,
        };
    },
    data() {
        return {
            name: '',
            isErrorName: false,
        };
    },
    methods: {
        resetErrors() {
            this.isErrorName = false;
        },
        cancel() {
            this.storeUI.setIsShowModal(false);
        },
        submit() {
            this.resetErrors();
            if (this.name.length < 2) {
                this.isErrorName = true;
                return;
            }

            this.storeProjectStructure.setCaseNameById(this.storeRenameCase.renameCaseId, this.name);
            this.storeNotifications
                .addNotification(generateNotification('caseRenamed','имя шкафа изменено.'), 2);
            this.storeUI.setIsShowModal(false);
        },
    },
    mounted() {
        this.name = this.storeRenameCase.renameCaseCurrentName;
    },
};
</script>

<style scoped lang="scss">
@import "CSS/modal";

.tc-modal-rename {
    width: 310px;
}
</style>
